import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=37d9056c&scoped=true&lang=pug&"
import script from "./QR.vue?vue&type=script&lang=ts&"
export * from "./QR.vue?vue&type=script&lang=ts&"
import style0 from "./QR.vue?vue&type=style&index=0&id=37d9056c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9056c",
  null
  
)

component.options.__file = "QR.vue"
export default component.exports